export default {
  data () {
    return {
      userAgent: null,
      viewerEnabled: null,
      mobileOS: 'unknown',
      forceMobileViewer: false,
      debugMobileViewer: false,
      debugDesktopViewer: false
    }
  },
  computed:{
    showMobileViewer () {
      if (this.debugMobileViewer) {
        return true
      }
      if (this.debugDesktopViewer) {
        return false
      }
      return (this.mobileOS !== 'unknown' || !this.viewerEnabled) && (this.mobileOS !== 'gekkodesktop')
    }
  },
  watch: {
    loadingPDF (newValue) {
      if (!newValue) {
        // wait for next tick so pdf-frame component is loaded
        this.$nextTick(() => {
          if (this.mobileOS !== 'gekkodesktop') {
            this.checkPDFfallback()
          }
        })
      }
    }
  },
  mounted () {
    this.userAgent = navigator.userAgent || navigator.vendor || window.opera;
    this.viewerEnabled = navigator.pdfViewerEnabled
    if (/windows phone/i.test(this.userAgent)) {
      this.mobileOS = 'Windows Phone'
    } else if (/android/i.test(this.userAgent)) {
      this.mobileOS = 'Android'
    } else if (!(/Windows/i.test(this.userAgent)) && !(/Macintosh/i.test(this.userAgent)) && parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.appVersion)[1], 10)) {
      this.mobileOS = 'AndroidDesktop'
    } else if (/iPad|iPhone|iPod/.test(this.userAgent) && !window.MSStream) {
      this.mobileOS = 'iOS'
    } else if (/Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1) {
      this.mobileOS = 'iOSDesktop'
    }
    if (/gekkodesktop/i.test(this.userAgent)) {
      this.mobileOS = 'gekkodesktop'
    }
    if (this.$route.query.debug === 'ua') {
      this.debug = true
      if (this.$route.query.ua === 'mobile') {
        this.debugMobileViewer = true
      }
      if (this.$route.query.ua === 'desktop') {
        this.debugDesktopViewer = true
      }
    }
  },
  methods: {
    checkPDFfallback () {
      const pdfFrame = document.getElementById('pdf-frame');
      // console.log('pdfFrame', pdfFrame)
      if (pdfFrame) {
        pdfFrame.onerror = () => {
          this.forceMobileViewer = true
        }
      }

      // Check if PDF loads successfully after a short delay
      setTimeout(() => {
        // console.log(pdfFrame)
        if (!this.debugDesktopViewer && (!pdfFrame || (pdfFrame.contentDocument && pdfFrame.contentDocument.body && pdfFrame.contentDocument.body.childElementCount === 0))) {
          this.forceMobileViewer = true
        } else if (!this.debugMobileViewer) {
          this.forceMobileViewer = false
        }
      }, 100);

    }
  }
}